<template>
  <div class="row">
    <div
      class="col-md-6 col-lg-4 mb-3 mb-md-4 pb-1"
      v-for="(hotelObj,hotelIndex) in lsHotels"
      :key="hotelIndex"
    >
      <div class="card transition-3d-hover shadow-hover-2 tab-card h-100" @click="onClickHotelCard(hotelObj)">
        <div class="position-relative">
          <a
            href="../hotels/hotel-single-v1.html"
            class="d-block gradient-overlay-half-bg-gradient-v5"
          >
            <img
              class="min-height-230 bg-img-hero card-img-top"
              src="@imgPathB2c/b2c/img/300x230/img9.jpg"
              alt="img"
            />
          </a>
          <div class="position-absolute top-0 right-0 pt-3 pr-3">
            <button
              type="button"
              class="btn btn-sm btn-icon text-white rounded-circle"
              data-toggle="tooltip"
              data-placement="top"
              title
              data-original-title="Save for later"
            >
              <span class="flaticon-valentine-heart"></span>
            </button>
          </div>
          <div class="position-absolute bottom-0 left-0 right-0">
            <div class="px-4 pb-3">
              <a href="../hotels/hotel-single-v1.html" class="d-block">
                <div class="d-flex align-items-center font-size-14 text-white">
                  <i class="icon flaticon-pin-1 mr-2 font-size-20"></i>
                  {{hotelObj.location.address.cityName+', '}}{{hotelObj.location.address.countryCode}}
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="card-body pl-3 pr-4 pt-2 pb-3">
          <div class="ml-1 mb-2">
            <div
              class="d-inline-flex align-items-center font-size-13 text-lh-1 text-primary letter-spacing-3"
            >
              <div class="green-lighter">
                <small class="fas fa-star"></small>
                <small class="fas fa-star"></small>
                <small class="fas fa-star"></small>
                <small class="fas fa-star"></small>
                <small class="fas fa-star"></small>
              </div>
            </div>
          </div>
          <a
            href="../hotels/hotel-single-v1.html"
            class="card-title font-size-17 font-weight-medium text-dark"
          >{{hotelObj.name}}</a>
          <div class="mt-2 mb-3">
            <span
              class="badge badge-pill badge-primary py-1 px-2 font-size-14 border-radius-3 font-weight-normal"
            >{{hotelObj.rating+'/5'}}</span>
            <span class="font-size-14 text-gray-1 ml-2">(166 reviews)</span>
          </div>
          <div class="mb-0">
            <span class="mr-1 font-size-14 text-gray-1">From</span>
            <span
              class="font-weight-bold"
              v-if="hotelObj&&hotelObj.rooms&&hotelObj.rooms[0].price.totalAmount"
            >£{{hotelObj.rooms[0].price.totalAmount}}</span>
            <span class="font-size-14 text-gray-1">/ night</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Logger from '../../../../services/logger';
import BaseConfiguration from '../../../../config/base';
import { LOG_TYPE } from '../../../../config/API_DATA';
export default {
  components: {},
  props: {
    lsHotels: {
      type: Array,
      default: []
    }
  },
  data: () => ({}),
  methods:{
      onClickHotelCard(pHotelObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onClickHotelCard");
       
       this.$emit('navToRoomSearch',pHotelObj);
      } catch (err) {
        let body = Logger.buildRequest(
           COMPONENT_NAME.C_HOTEL_LIST_VIEW,
          "error in onClickHotelCard",
          err.toString(),
          "onClickHotelCard",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
  }
};
</script>
